import React from 'react';
import stylesHeaderStep from './HeaderStep.module.scss';

const HeaderStep = (props) =>{
    return (
        <div className={stylesHeaderStep.HeaderStep}>
            <h2 className={stylesHeaderStep.TitoloStep}>{props.titolo}</h2>
            <h3 className={stylesHeaderStep.SottotitoloStep}>{props.sottotitolo}</h3>
        </div>
    )
}

export default HeaderStep;